import * as firebase from "firebase";
import i18n from "@/i18n";
import { mapGetters } from "vuex";

const firebaseDatabase = {
  created() {
    this.bindLiveConsumersWithFBase();
  },
  computed: {
    ...mapGetters("app", {
      liveConsumers: "getLiveConsumers",
    }),
  },

  methods: {
    // Add consumer to live_users reference
    async addConsumerToLiveConsumers(screenerId, consumerId) {
      console.log("Adding consumer to live_users");
      const sessionRef = firebase
        .database()
        .ref(`live_users/${screenerId}/${consumerId}`);

      // Add consumer session with timestamp
      sessionRef
        .set({ joinedAt: Date.now() })
        .catch((error) =>
          console.error("Firebase addConsumer error:", error)
        );

      // Remove consumer on disconnect
      sessionRef.onDisconnect().remove();
    },

    // Remove consumer explicitly
    async removeConsumerFromLiveConsumers(screenerId, consumerId) {
      console.log("Removing consumer from live_users");
      return firebase
        .database()
        .ref(`live_users/${screenerId}/${consumerId}`)
        .remove()
        .catch((error) =>
          console.error("Firebase removeConsumer error:", error)
        );
    },

    // Bind live consumer count to Vuex store
    async bindLiveConsumersWithFBase(screenerId) {
      console.log("Binding live consumers with Firebase");
      const _this = this;

      return firebase
        .database()
        .ref(`live_users/${screenerId}`)
        .on("value", function (snapshot) {
          const consumerCount = snapshot.exists()
            ? Object.keys(snapshot.val()).length
            : 0;

          console.log("Live Consumers Count:", consumerCount);
          _this.$store.dispatch("app/setLiveConsumers", consumerCount);
        });
    },
        async bindSessionWithFBase(consumerId) {
            let _this = this
            firebase.database().ref(`/consumer_sessions/${consumerId}`).on('value', function(snapshot) {
                let currentSessionKey = _this.$store.getters['auth/getSession'].key;
                let activeSessionKey = snapshot.val();
                /**
                 * Logout if following condition meets
                 * 1. Current session is available (Client side session)
                 * 2. Active session is available (Firebase side session)
                 * 3. If keys of CurrentSession and ActiveSession mismatched
                 */
                if(currentSessionKey && activeSessionKey && (activeSessionKey != currentSessionKey)){
                    _this.$store.dispatch ('auth/logout');
                    _this.$store.dispatch("app/showMessage", {
                        message: i18n.t('session.expired.message'),
                        color: "error",
                    });
                }
            })
        },
        async uploadChatMemberAvatar(eventid,chatroom_uuid,consumerId,base64Data) {
            return firebase
                .database()
                .ref("chat_room")
                .child(chatroom_uuid)
                .child("profile_images")
                .set({
                    consumer_id:consumerId,
                    event_id:eventid,
                    base64: base64Data,
                    timestamp: firebase.database.ServerValue.TIMESTAMP
                })
                .then(function(snapshot) {
                    // _this.liveUsers = snapshot.val();
                })
                .catch((error) => {
                    console.error('Firebase error ==>',error);
                });
        },


    // Bind consumer session validation with Firebase
    async bindSessionWithFBase(consumerId) {
      console.log("Binding consumer session with Firebase");
      const _this = this;

      firebase
        .database()
        .ref(`/consumer_sessions/${consumerId}`)
        .on("value", function (snapshot) {
          let currentSessionKey = _this.$store.getters["auth/getSession"].key;
          let activeSessionKey = snapshot.val();

            /**
             * Logout if following condition meets
             * 1. Current session is available (Client side session)
             * 2. Active session is available (Firebase side session)
             * 3. If keys of CurrentSession and ActiveSession mismatched
             */
          if (
            currentSessionKey &&
            activeSessionKey &&
            activeSessionKey !== currentSessionKey
          ) {
            _this.$store.dispatch("auth/logout");
            _this.$store.dispatch("app/showMessage", {
              message: i18n.t("session.expired.message"),
              color: "error",
            });
          }
        });
    },

    // Wrapper for consumer lifecycle on a page
    manageConsumerLifecycle(screenerId, consumerId) {
      // Add the consumer when component is created
      this.addConsumerToLiveConsumers(screenerId, consumerId);

      // Remove the consumer when the page is closed
      window.addEventListener("beforeunload", () => {
        this.removeConsumerFromLiveConsumers(screenerId, consumerId);
      });
    },
  },
};

export { firebaseDatabase };
